import useAuth from "libs/hooks/useAuth";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { logout } from "redux/modules/authSlice";

export default function LogoutPage() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { accessToken } = useAuth();

  useEffect(() => {
    dispatch(logout());
  }, [dispatch]);

  useEffect(() => {
    if (!accessToken) {
      history.replace("/");
    }
  }, [accessToken, history]);

  return <div>Logout...</div>;
}
